import React, { useCallback, useEffect, useState } from "react";
import TableWithSearchAndPagination from "../../../components/tableWithSearchAndPagination";
import Button from "../../../components/button";
import {
  deleteRoleById,
  rolesListPage,
} from "../../../services/permissions/roles";
import WithHeaderSidebar from "../../../layout/withHeaderSidebar";
import WithAuth from "../../../layout/withAuth";
import { useNavigate } from "react-router-dom";
import CheckPermission from "../../../components/checkPermission";
import { handleDrawer } from "../../../actions/userActions";
import { connect } from "react-redux";

const headings = [
  {
    label: "Role Id",
    width: "10%",
    align: "left",
  },
  {
    label: "Role Name",
    width: "30%",
    align: "left",
  },
  {
    label: "Role Description",
    width: "40%",
    align: "left",
  },
  {
    label: "Actions",
    width: "20%",
    align: "center",
  },
];

const dataToShow = [
  {
    key: "roleId",
    align: "left",
  },
  {
    key: "roleName",
    align: "left",
  },
  {
    key: "roleDescription",
    align: "left",
  },
];

const Roles = ({ handleDrawer }) => {
  const navigate = useNavigate();
  const [totalData, setTotalData] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [callbackAttributes, setCallbackAttributes] = useState({
    searchSend: "",
    perPage: "25",
    selectedPage: "0",
    sort: "",
  });
  const [rolesList, setRolesList] = useState([]);

  const displayRolesList = useCallback(() => {
    setRolesList([]);
    const { searchSend, selectedPage, perPage, sort } = callbackAttributes;
    let data = `searchKey=${searchSend}&page=${selectedPage}&size=${perPage}&sort=${sort}`;
    rolesListPage(data).then((res) => {
      if (res?.status === 200) {
        setRolesList(res?.result?.rolesList || []);
        setTotalData(res?.result?.getTotalRecords || 0);
        setTotalPages(res?.result?.getTotalPages || 0);
      } else {
        // props?.setSnackbar({
        //     showSnackbar: true,
        //     message: res?.message,
        //     variant: "error"
        // })
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callbackAttributes]);

  useEffect(() => {
    displayRolesList();
  }, [displayRolesList, callbackAttributes]);

  const handleDelete = (item) => {
    deleteRoleById(item.roleId).then((res) => {
      if (res.status === 200) {
        displayRolesList();
      }
    });
  };

  const handleEdit = (item) => {
    navigate("/roles/edit/" + item.roleId);
  };

  return (
    <div className="h-full">
      <div className="p-5 sm:pl-8 sm:pt-7 sm:pb-[23px] flex items-center md:block gap-5">
        <button className="md:hidden" onClick={handleDrawer}>
          <i class="fa-solid fa-list"></i>
        </button>
        <p className="text-xl md:text-2xl md:leading-6 text-[#404040] font-bold">
          Roles
        </p>
      </div>
      <div className="bg-[#F7F8F9] sm:pt-[18px] p-5 sm:pl-7 sm:pr-11 sm:pb-9">
        <div className="bg-white w-full h-full shadow-[0px_9px_20px] shadow-[#2E235E1A] rounded-[15px]">
          <div className="flex flex-row items-center justify-between p-3 sm:p-7 border-b ">
            <p className="text-base md:text-xl leading-6 text-[#404040] font-bold">
              Roles List
            </p>
            <CheckPermission module="Roles" permission="Add">
              <Button
                text="New Entry"
                onClick={() => {
                  navigate("/roles/add");
                }}
              />
            </CheckPermission>
          </div>
          <div className="p-3 sm:p-7 sm:pt-5">
            <TableWithSearchAndPagination
              headings={headings}
              dataToShow={dataToShow}
              data={rolesList}
              totalData={totalData}
              totalPages={totalPages}
              actions={["delete", "edit"]}
              setCallbackAttributes={setCallbackAttributes}
              handleActionEdit={handleEdit}
              handleActionDelete={handleDelete}
              module="Roles"
              actionPermission={{
                edit: "Edit",
                delete: "Delete",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    doctorId: state.user.doctorId,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    handleDrawer: () => dispatch(handleDrawer()),
  };
};
export default WithAuth(WithHeaderSidebar(connect(mapStateToProps, mapDispatchToProps)(Roles)));
